// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-7jzBK","header":"header-2pKgu","body":"body-1r2gd","footer":"footer-3H3Y3","title":"title-UVcAa","modal-lg":"modal-lg-pMCoI","modalLg":"modal-lg-pMCoI"};